import { Col, Divider, Row } from 'antd';
import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { Link } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { ItemBox } from '../../CU-015-01/components/ItemBox';
import { ItemView } from '../../CU-015-02/components/ItemView';
import { StepProps } from '../props/StepProps';

export const StepViewTwo = ({ data, masterData }: StepProps) => {
    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[32px]">
                    <span className="content-step-form label-step-form">
                        契約予定日前後でメッセージから予定日を設定させていただきます。
                    </span>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="契約予定日"
                                value={data?.scheduleContactDate}
                                type="date"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="w-full mb-[32px]">
                    <span className="content-step-form heading-step-form">売買代金</span>
                    <Divider className="mb-6 my-1" />
                    <Row>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="購入価格"
                                value={data?.purchasePriceExcludingBrokerageFee}
                                type="number"
                                suffix="円"
                                className="mb-[12px]"
                            // roundFunction={(value: any) => {
                            //     if (value) {
                            //         return commonHelpers.roundTenThousandYen(value) * 10000;
                            //     }
                            //     return value;
                            // }}
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="仲介手数料"
                                value={data?.brokerageFeeSpecificTreat ?? ''}
                                type="number"
                                suffix="円"
                                className="mb-[12px]"
                                defaultvalue={0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="代金総額"
                                value={data?.totalPrice}
                                type="number"
                                suffix="円"
                                className="mb-[12px]"
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="手付金"
                                value={data?.deposit}
                                type="number"
                                suffix="円"
                                className="mb-[12px]"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="手付金振込予定日"
                                value={data?.scheduleContactDate}
                                type="date"
                                className="mb-[12px]"
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="最終金"
                                value={data?.finalPayment}
                                type="number"
                                suffix="円"
                                className="mb-[12px]"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="最終金振込予定日"
                                value={data?.scheduleFinalPaymentDate}
                                type="date"
                                className="mb-[12px]"
                            />
                        </Col>
                    </Row>
                    {/* <Row className="mt-[12px]">
                        <Col span={24} className="pr-[12px]">
                            <FormCheckBox
                                name="includeBrokerageFee"
                                disabled
                                className="mb-0"
                                options={[
                                    {
                                        value: 1,
                                        label: '仲介手数料を購入価格に組み込む。',
                                    },
                                ]}
                            />
                        </Col>
                    </Row> */}
                </div>
                <div className="w-full mb-[32px]">
                    <Row gutter={[0, 12]} className="my-[12px]">
                        <Col span={4} className="pr-[12px]">
                            <span className="content-step-form heading-step-form">賃貸管理</span>
                        </Col>
                        <Col span={20} className="pr-[12px]">
                            <span className="flex justify-start label-step-form">
                                詳しくは
                                <a href={LINK_URL.MANAGEMENT_RENT_DETAIL} target="_blank" rel="noopener noreferrer" className="link-component">
                                    こちら
                                </a>
                            </span>
                        </Col>
                    </Row>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <FormCheckBox
                                name="confirm_cic"
                                required
                                showErrorMessage={false}
                                className="mb-0"
                                options={[
                                    {
                                        value: '1',
                                        label: '株式会社シイ・アイ・シーに賃貸管理業務を委託することに同意します。',
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[32px]">
                    <span className="content-step-form heading-step-form">取引目的</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="my-[12px]">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                options={
                                    masterData?.[
                                    MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="取引目的"
                                value={data?.dealPurposeType}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="その他目的"
                                value={data?.dealPurposeOthers}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <ItemView
                                label="キャンペーンコード（任意）"
                                value={data?.campaignCode}
                                labelClassName="content-step-form label-step-form"
                                defaultValue={'なし'}
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
